import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import usePageMeta from "../hooks/usePageMeta";
import DeviceKioskHeader from "./DeviceKioskHeader";
import { resolveKioskSearchFromStorage } from "./deviceKiosk";
import { loadManageSession } from "./manageSession";

export default function DeviceHome() {
  usePageMeta("Time Tracker");
  const navigate = useNavigate();
  const location = useLocation();
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    if (location.state?.skipAutoRedirect) return;
    const { token } = loadManageSession();
    if (!token) return;
    const kioskSearch = resolveKioskSearchFromStorage();
    if (kioskSearch) {
      navigate(`/checkin?${kioskSearch.toString()}`, { replace: true });
      return;
    }
    navigate("/device/assign", { replace: true });
  }, [location.state?.skipAutoRedirect, navigate]);

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
      <DeviceKioskHeader now={now} />
      <main className="flex-1 flex flex-col items-center justify-center px-4 pb-10">
        <h1 className="mb-10 text-center text-2xl text-gray-700">Time Tracker</h1>
        <div className="relative h-44 w-44 rounded-full bg-[#acacac]">
          <span className="absolute left-[86px] top-[44px] h-14 w-3 rounded-sm bg-white" />
          <span className="absolute left-[89px] top-[95px] h-3 w-14 rotate-45 rounded-sm bg-white origin-left" />
        </div>
      </main>
      <div className="px-4 pb-6">
        <button
          type="button"
          onClick={() => navigate("/device/signin")}
          className="w-full py-2 text-center text-sm font-medium uppercase tracking-wide text-[#DC1F00] hover:text-[#b91900] transition-colors"
        >
          Assign Device
        </button>
      </div>
    </div>
  );
}
